
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { isEdit } from './Footer.config';
import { MoveToTopData, MoveToTopMethods, MoveToTopComputed, MoveToTopProps } from './MoveToTop';
/**
 * `Move To Top Footer` - Move To Top Footer for OneWeb - This component allows the user to navigate to the top of the page if the component is clicked
 */

export default ComponentInitializeDispatcher.extend<
  MoveToTopData,
  MoveToTopMethods,
  MoveToTopComputed,
  MoveToTopProps
>({
  name: 'owc-move-to-top',
  props: {
    moveToTop: {
      type: Object,
    },
  },
  computed: {
    text: function(): string {
      return isEdit ? this.componentData?.text : this.moveToTop?.text;
    },
  },
  methods: {
    scrollToTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
  },
});
